import { Component, ElementRef, effect, inject, input, signal, viewChild } from '@angular/core';
import { IonToggle } from '@ionic/angular/standalone';
import { ThemeStore } from '@libs/core/lib/utils/theme/theme.store';

@Component({
  selector: 'mtjr-theme-toggle',
  imports: [IonToggle],
  template: `
    <ion-toggle
      dir="ltr"
      #toggle
      mode="ios"
      class="scale-90"
      color="light"
      (ionChange)="toggleInternal($event)"
      [checked]="themeStore.usingDarkTheme()"
    >
      <ng-content></ng-content>
    </ion-toggle>
  `,
  styles: [
    `
      ion-toggle::part(handle) {
        background-repeat: no-repeat;
        background-size: 70%;
        background-position: center;
      }
    `,
  ],
})
export class ThemeToggleComponent {
  themeStore = inject(ThemeStore);
  toggle = viewChild.required('toggle', { read: ElementRef });
  handle = signal<HTMLElement | null>(null);
  disabled = input(false);

  toggleTheme(): void {
    this.themeStore.toggleTheme();
  }

  protected toggleInternal(event: CustomEvent): void {
    if (this.disabled()) return;
    this.toggleTheme();
    event.stopPropagation();
  }

  constructor() {
    effect(async () => {
      const toggleEl = await this.toggle().nativeElement;
      if (!toggleEl) return;
      const shadowRoot = toggleEl.shadowRoot as ShadowRoot;
      shadowRoot.onslotchange = () => {
        this.handle.set(shadowRoot.querySelector('.toggle-inner'));
      };
    });

    effect(() => {
      const handle = this.handle();
      const isDark = this.themeStore.usingDarkTheme();
      if (!handle) return;
      if (isDark) {
        handle.style.background = 'url("/assets/icons/moon.svg")';
        handle.style.backgroundColor = '#000';
      } else {
        handle.style.background = 'url("/assets/icons/sun.svg")';
        handle.style.backgroundColor = '#fff';
      }
    });
  }
}
